import { render, staticRenderFns } from "./RenameFloor.vue?vue&type=template&id=2c7b0214&scoped=true"
import script from "./RenameFloor.vue?vue&type=script&setup=true&lang=ts"
export * from "./RenameFloor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RenameFloor.vue?vue&type=style&index=0&id=2c7b0214&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b0214",
  null
  
)

export default component.exports